<template>
  <div style="background: #f6f7f8; position: relative">
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240)"
      :title="$t('service.standards')"
      sub-title=""
      @back="back()"
    />

    <a-anchor
      class="anchor"
      :affix="true"
      :items="[
        {
          key: '1',
          href: '#onSite',
          title: '上门维修',
        },
        {
          key: '2',
          href: '#valueAdded',
          title: '增值服务',
        },
        {
          key: '3',
          href: '#fiveYear',
          title: '五年质保',
        },
      ]"
      @click="handleClick"
    ></a-anchor>

    <div class="inner">
      <div class="navi">
        <div class="naviCard" @click="jump('onSite')">
          <div class="title">上门维修</div>
          <div class="describe">在线申请,免费上门</div>
          <div class="hoverImg"></div>
        </div>
        <div class="naviCard" @click="jump('valueAdded')">
          <div class="title">增值服务</div>
          <div class="describe">多重保障,让您购机无忧</div>
          <div class="hoverImg"></div>
        </div>
        <div class="naviCard" @click="jump('fiveYear')">
          <div class="title">五年质保</div>
          <div class="describe">自研核心三大件,五年质保</div>
          <div class="hoverImg"></div>
        </div>
      </div>

      <a-card class="contentCard" title="上门维修" id="onSite">
        <a-typography-title :level="4" style="text-align: center"
          >报修流程</a-typography-title
        >
        <a-steps style="margin: 40px 0px" :items="repairItems"></a-steps>
        <a-typography-title :level="4" style="text-align: center"
          >注意事项</a-typography-title
        >
        <a-list item-layout="vertical" size="large" :data-source="listData1">
          <template #renderItem="{ item }">
            <a-list-item key="item.title">
              <a-list-item-meta :description="item.description">
                <template #title>
                  <a>{{ item.title }}</a>
                </template>
                <template #avatar><a-avatar :src="item.avatar" /></template>
              </a-list-item-meta>
              <pre class="artticle">{{ item.content }}</pre>
            </a-list-item>
          </template>
        </a-list>
      </a-card>

      <a-card class="contentCard" title="增值服务" id="valueAdded">
        <a-typography-title :level="4" style="text-align: center"
          >服务产品</a-typography-title
        >
        <a-row style="margin: 30px 0px">
          <a-col :span="8">
            <div class="itemCard" style="height: 420px">
              <svg
                class="mg-a tc"
                xmlns="http://www.w3.org/2000/svg"
                width="60"
                height="60"
                viewBox="0 0 60 60"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M28.125 41.25V48.75H11.25V52.5H48.75V48.75H31.875V41.25H50.625C52.6961 41.25 54.375 39.5711 54.375 37.5V11.25C54.375 9.17894 52.6961 7.5 50.625 7.5H9.375C7.30393 7.5 5.625 9.17894 5.625 11.25V37.5C5.625 39.5711 7.30393 41.25 9.375 41.25H28.125ZM9.375 37.5L50.625 37.5V11.25L9.375 11.25L9.375 37.5Z"
                  fill="black"
                  fill-opacity="0.9"
                ></path>
              </svg>
              <div class="itemtitle">整机/辅机上门保养</div>
              <div class="itemdescribe">
                通过400热线预约服务工程师进行上门保养服务，现场结算即可
              </div>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="itemCard" style="margin-bottom: 20px">
              <img class="itemImg" src="@/assets/img/icon/设备移机.svg" />
              <div class="itemtitle">设备移机</div>
              <div class="itemdescribe">通过400热线预约服务工程师进行移机服务</div>
            </div>
            <div class="itemCard">
              <img class="itemImg" src="@/assets/img/icon/延保服务.svg" />
              <div class="itemtitle">延保服务</div>
              <div class="itemdescribe">通过与服务工程师签订购买合同购买延保服务</div>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="itemCard" style="margin-bottom: 20px">
              <img class="itemImg" src="@/assets/img/icon/二次培训.svg" />
              <div class="itemtitle">二次培训</div>
              <div class="itemdescribe">
                通过400热线预约服务工程师进行操作软件二次培训服务
              </div>
            </div>
            <div class="itemCard">
              <img class="itemImg" src="@/assets/img/icon/上门维修.svg" />
              <div class="itemtitle">上门检测/维修</div>
              <div class="itemdescribe">
                通过400热线预约服务工程师进行上门检测/维修服务，现场结算即可
              </div>
            </div>
          </a-col>
        </a-row>

        <a-typography-title :level="4" style="text-align: center"
          >升级改造</a-typography-title
        >
        <a-row style="margin: 30px 0px">
          <a-col :span="12">
            <div class="itemCard" style="height: 320px">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="60"
                height="60"
                viewBox="0 0 60 60"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M43.8675 16.7759L41.1001 19.5433C37.7709 17.8375 33.9978 16.875 30 16.875C16.8307 16.875 6.10069 27.3187 5.64039 40.3757L5.625 41.25H1.875C1.875 25.717 14.467 13.125 30 13.125C35.0425 13.125 39.7751 14.452 43.8675 16.7759ZM51.7067 30.1499L54.4741 27.3825C56.6576 31.2277 57.9611 35.6381 58.1106 40.3398L58.125 41.25H54.375C54.375 37.2522 53.4125 33.4791 51.7067 30.1499ZM52.539 16.0593L28.6742 39.9242L31.3258 42.5758L55.1907 18.711L52.539 16.0593Z"
                  fill="black"
                  fill-opacity="0.9"
                ></path>
              </svg>
              <div class="itemtitle">功率升级</div>
              <div class="itemdescribe">通过与服务工程师签订购买合同进行功率升级</div>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="itemCard" style="height: 320px">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="60"
                height="60"
                viewBox="0 0 60 60"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M49.7004 29.9951H53.3054C53.3054 17.0536 42.8715 6.5625 30.0006 6.5625C21.6143 6.5625 14.2626 11.0164 10.1576 17.7L10.1576 9.90945H6.5625V22.9335C6.5625 23.2097 6.78636 23.4335 7.0625 23.4335L20.0128 23.4335V19.8187L13.0892 19.8187C16.534 14.0329 22.8259 10.1675 30.0006 10.1675C40.8619 10.1675 49.7004 19.026 49.7004 29.9951ZM10.3008 29.9949C10.3008 40.9639 19.1392 49.8226 30.0006 49.8226C37.1752 49.8226 43.4672 45.9572 46.912 40.1714H39.9872V36.5566H52.9375C53.2136 36.5566 53.4375 36.7805 53.4375 37.0566V50.0807H49.8424V42.292C45.7372 48.9745 38.3861 53.4276 30.0006 53.4276C17.1297 53.4276 6.69576 42.9363 6.69577 29.9949H10.3008Z"
                  fill="black"
                  fill-opacity="0.9"
                ></path>
              </svg>
              <div class="itemtitle">设备改装</div>
              <div class="itemdescribe">通过与服务工程师签订购买合同进行设备改装</div>
            </div>
          </a-col>
        </a-row>
      </a-card>

      <a-card class="contentCard" title="五年质保" id="fiveYear">
        <div class="column">
          <a-typography-title :level="4" style="text-align: center"
            >五年质保 颠覆行业</a-typography-title
          >
          <a-typography-paragraph style="text-align: center">
            操作系统、激光器、激光头品质升级
          </a-typography-paragraph>

          <video
            class="fourthly-media"
            loop=""
            autoplay=""
            muted=""
            width="100%"
            height="100%"
          >
            <source :src="assetsUrl[0]" type="video/mp4" />
            <p>你的浏览器不支持 HTML5 Video。</p>
          </video>

          <a-typography-title :level="4" style="text-align: center"
            >自研核心三大件 一体化</a-typography-title
          >
          <div class="three">
            <div class="three-item">
              <div class="three-title">一体化设计</div>
              <img
                class="three-img"
                src="@/assets/img/service/一体化设计.png"
                alt="一体化设计"
              />
              <div class="three-info">
                <div>
                  上千张图纸<br />
                  20万次参数磨合<br />
                  MTBF*超过45000小时<br />
                  邦德突破行业困局<br />
                  设计了自研核心三大件一体化工艺<br />
                  彼此完美适配，协作稳定如一
                </div>

                <div class="three-explain">
                  *MTBF（Mean Time Between
                  Failure）即平均无故障工作时间，是衡量一个产品（尤其是电器产品）的可靠性指标。
                </div>
              </div>
            </div>

            <div class="three-item">
              <div class="three-title">一体化生产</div>
              <img
                class="three-img"
                src="@/assets/img/service/一体化生产.png"
                alt="一体化生产"
              />
              <div class="three-info">
                <div>
                  一体化生产流程
                  <br />
                  超洁净生产环境*
                  <br />
                  覆盖每一道生产工序的严苛质量管理
                  <br />
                  确保自研核心三大件自成一体
                  <br />
                  性能稳定 品质如一<br />
                </div>

                <div class="three-explain">
                  *邦德激光配置了业内一流的生产环境——千级洁净车间、百级洁净FFU工作台。千级洁净车间主要用于生产精密光学产品，百级洁净主要用于对洁净度要求极高的领域（比如医药行业的无菌制造、移植手术等）
                </div>
              </div>
            </div>

            <div class="three-item">
              <div class="three-title">一体化检测</div>
              <img
                class="three-img"
                src="@/assets/img/service/一体化检测.png"
                alt="一体化检测"
              />
              <div class="three-info">
                <div>
                  自研核心三大件一体化
                  <br />
                  经连续24小时出光
                  <br />
                  90余项切割作业测试
                  <br />
                  达到对应功率的最优切割性能后<br />
                  才能封装出库
                  <br />
                </div>
              </div>
            </div>

            <div class="three-item">
              <div class="three-title">一体化交付</div>
              <img
                class="three-img"
                src="@/assets/img/service/一体化交付.png"
                alt="一体化交付"
              />
              <div class="three-info" style="line-height: normal">
                <div>
                  01<br />一体化打包、装车、交付<br />避免污染和磕碰故障<br />
                  <br />
                  02<br />结合专业团队培训<br />操作使用、工艺调试、保养更简单<br />
                  <br />
                  03<br />服务网络覆盖<br />全球180多个国家和地区<br />7×24小时响应服务需求
                  <br />
                </div>
              </div>
            </div>
          </div>

          <a-typography-title :level="4" style="text-align: center"
            >性能跃升 破解行业难题</a-typography-title
          >
          <a-typography-paragraph style="text-align: center">
            自研核心三大件一体化， 完美解决核心部件“拼装、混装”带来的各类难题。
          </a-typography-paragraph>

          <div class="flex-bet" style="margin-top: 20px">
            <div class="orangeCard">
              <img src="@/assets/img/service/yes.png" alt="" />
              <div class="orange-title">
                三大件彼此完美适配<br />
                综合性能实现最大化
              </div>
            </div>
            <div class="orangeCard">
              <img src="@/assets/img/service/yes.png" alt="" />
              <div class="orange-title">
                大幅降低三大部件<br />
                连接处的故障率
              </div>
            </div>
            <div class="orangeCard">
              <img src="@/assets/img/service/yes.png" alt="" />
              <div class="orange-title">
                无需反复组装、拆卸和维保<br />
                降低维护成本
              </div>
            </div>
          </div>
          <div class="flex-bet" style="margin: 37px 0px 40px">
            <div class="orangeCard" style="width: 514px">
              <img src="@/assets/img/service/yes.png" alt="" />
              <div class="orange-title">
                在多次运输和拆装<br />
                过程中不易受到污染
              </div>
            </div>
            <div class="orangeCard" style="width: 514px">
              <img src="@/assets/img/service/yes.png" alt="" />
              <div class="orange-title">
                杜绝因部件多方拼装产生质量问题<br />
                发生售后纠纷、互相推诿等类似现象
              </div>
            </div>
          </div>

          <a-typography-title :level="4" style="text-align: center"
            >敢于承诺 源于自研品质</a-typography-title
          >
          <a-typography-paragraph style="text-align: center">
            超一流的生产环境和技术、严苛标准的质量管控，成就硬核品质，彰显品牌自信。
          </a-typography-paragraph>

          <video
            class="fourthly-media"
            loop=""
            autoplay=""
            muted=""
            controls=""
            width="100%"
            height="100%"
          >
            <source :src="assetsUrl[1]" type="video/mp4" />
            <p>你的浏览器不支持 HTML5 Video。</p>
          </video>

          <a-typography-title :level="4" style="text-align: center"
            >金牌团队 金牌服务</a-typography-title
          >
          <a-typography-paragraph style="text-align: center">
            专业服务团队，给你五星保障
          </a-typography-paragraph>

          <div class="flex-bet" style="margin-top: 20px">
            <div class="teamCard" style="background-color: #fffef0">
              <div class="team-front">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="65"
                  height="64"
                  viewBox="0 0 65 64"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M32.7731 34C27.2502 34 22.7731 29.5228 22.7731 24C22.7731 18.4771 27.2502 14 32.7731 14C38.2959 14 42.7731 18.4771 42.7731 24C42.7731 29.5228 38.2959 34 32.7731 34ZM32.7731 30C29.4593 30 26.7731 27.3137 26.7731 24C26.7731 20.6862 29.4593 18 32.7731 18C36.0868 18 38.7731 20.6862 38.7731 24C38.7731 27.3137 36.0868 30 32.7731 30ZM31.3256 57.8736L16.195 35.647C10.7744 27.6841 11.7808 16.9922 18.5922 10.1808C26.4241 2.34892 39.122 2.34892 46.9539 10.1808C53.7653 16.9922 54.7717 27.6841 49.3511 35.647L34.2205 57.8736C33.5256 58.8945 32.0206 58.8945 31.3256 57.8736ZM32.7731 52.8917L19.5016 33.396C15.1621 27.0214 15.9678 18.462 21.4207 13.0092C27.6904 6.73945 37.8557 6.73944 44.1255 13.0092C49.5783 18.462 50.384 27.0214 46.0446 33.3961L32.7731 52.8917Z"
                    fill="black"
                    fill-opacity="0.9"
                  ></path>
                </svg>
                <div class="team-title">网点覆盖-<strong>广</strong></div>
              </div>
              <div class="team-back">
                300余名资深服务工程师<br />
                全国60+服务网点<br />
                辐射全国600多个城市<br />
                无论您在哪<br />
                我们都能抵达
              </div>
            </div>
            <div class="teamCard" style="background-color: #f0fffb">
              <div class="team-front">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="65"
                  height="64"
                  viewBox="0 0 65 64"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M30.6195 5.38581L28.0984 8.63439C27.0696 8.22505 25.9475 8 24.7728 8C19.8022 8 15.7728 12.0294 15.7728 17C15.7728 21.9087 19.7025 25.8995 24.5876 25.9981V29.9987C17.4933 29.8996 11.7728 24.1179 11.7728 17C11.7728 9.8203 17.5931 4 24.7728 4C26.8757 4 28.862 4.4993 30.6195 5.38581ZM24.5876 32.8838V36.8838C17.5095 36.9109 10.8156 38.4952 4.77271 41.301V47.9999H12.2011V51.9999H2.7727C1.66813 51.9999 0.772705 51.1045 0.772705 49.9999V41.2346C0.772705 39.7488 1.59085 38.3737 2.93642 37.7437C9.5294 34.6568 16.8496 32.9112 24.5876 32.8838ZM53.7724 20.2542C53.7724 13.0744 47.9521 7.25415 40.7724 7.25415C33.5927 7.25415 27.7724 13.0744 27.7724 20.2542C27.7724 27.4339 33.5927 33.2542 40.7724 33.2542C47.9521 33.2542 53.7724 27.4339 53.7724 20.2542ZM49.7724 20.2542C49.7724 15.2836 45.743 11.2542 40.7724 11.2542C35.8018 11.2542 31.7724 15.2836 31.7724 20.2542C31.7724 25.2247 35.8018 29.2542 40.7724 29.2542C45.743 29.2542 49.7724 25.2247 49.7724 20.2542ZM62.6089 42.5805C55.9634 39.4689 48.579 37.7202 40.7726 37.7202C32.9662 37.7202 25.5818 39.4689 18.9363 42.5805C17.5907 43.2105 16.7726 44.5856 16.7726 46.0713V56C16.7726 57.1045 17.668 58 18.7726 58H62.7726C63.8772 58 64.7726 57.1045 64.7726 56V46.0713C64.7726 44.5856 63.9545 43.2105 62.6089 42.5805ZM40.7726 41.7202C33.6261 41.7202 26.8681 43.3075 20.7726 46.1377V54H60.7726V46.1377C54.6771 43.3075 47.9191 41.7202 40.7726 41.7202Z"
                    fill="black"
                    fill-opacity="0.9"
                  ></path>
                </svg>
                <div class="team-title">团队专业-<strong>强</strong></div>
              </div>
              <div class="team-back">
                每一位邦德激光服务工程师，<br />
                均具备丰富的激光技术知识和实践经验<br />
                不仅能够为您提供高效、<br />
                专业的售后服务，<br />
                还可以为您科普设备使用、<br />
                保养、维修知识。
              </div>
            </div>
          </div>
          <div class="flex-bet" style="margin: 37px 0px 40px">
            <div class="teamCard" style="background-color: #f3fdff">
              <div class="team-front">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="65"
                  height="64"
                  viewBox="0 0 65 64"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M47.5647 17.8943L44.6128 20.8462C41.0617 19.0266 37.0371 18 32.7727 18C18.7255 18 7.2801 29.14 6.78912 43.0675L6.77271 44H2.77271C2.77271 27.4315 16.2042 14 32.7727 14C38.1514 14 43.1995 15.4155 47.5647 17.8943ZM55.9265 32.1599L58.8784 29.208C61.2075 33.3096 62.5978 38.014 62.7573 43.0291L62.7727 44H58.7727C58.7727 39.7356 57.7461 35.711 55.9265 32.1599ZM56.8143 17.1299L31.3585 42.5858L34.1869 45.4142L59.6428 19.9584L56.8143 17.1299Z"
                    fill="black"
                    fill-opacity="0.9"
                  ></path>
                </svg>
                <div class="team-title">响应速度-<strong>快</strong></div>
              </div>
              <div class="team-back">
                24小时在线客服，<br />
                无论您何时何地遇到什么问题，<br />
                都能够及时得到解决。<br />
                对于紧急情况，<br />
                我们还可以提供现场服务，<br />
                快速解决问题。
              </div>
            </div>
            <div class="teamCard" style="background-color: #f3edff">
              <div class="team-front">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="65"
                  height="64"
                  viewBox="0 0 65 64"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12.7727 8H52.7727C54.9818 8 56.7727 9.79086 56.7727 12V19.1439L39.7727 29.1439V56H25.7727V29.1439L8.77271 19.1439V12C8.77271 9.79086 10.5636 8 12.7727 8ZM12.7727 12V16.8561L29.7727 26.8561V52H35.7727V26.8561L52.7727 16.8561V12H12.7727Z"
                    fill="black"
                    fill-opacity="0.9"
                  ></path>
                </svg>
                <div class="team-title">质量管控-<strong>严</strong></div>
              </div>
              <div class="team-back">
                我们会与您签订服务合同，<br />
                明确服务内容和质量标准。<br />
                并且对服务过程进行全面监控，<br />
                确保服务质量让您满意。
              </div>
            </div>
          </div>
        </div>
      </a-card>
    </div>
  </div>
</template>

<script setup>
import { ref, h } from "vue";
import { useRouter } from "vue-router";
import { message } from "ant-design-vue";
import { useI18n } from "vue-i18n";
import axios from "axios";
import {
  UserOutlined,
  SolutionOutlined,
  LoadingOutlined,
  SmileOutlined,
  ClockCircleOutlined,
  FileDoneOutlined,
  ToolOutlined,
} from "@ant-design/icons-vue";

let router = useRouter();
/**步骤条内容 */
const repairItems = [
  {
    title: "客户报修",
    status: "finish",
    icon: h(SolutionOutlined),
  },
  {
    title: "客服派单",
    status: "finish",
    icon: h(FileDoneOutlined),
  },
  {
    title: "工程师接单",
    status: "finish",
    icon: h(UserOutlined),
  },
  {
    title: "预约时间",
    status: "finish",
    icon: h(ClockCircleOutlined),
  },
  {
    title: "上门维修",
    status: "finish",
    icon: h(ToolOutlined),
  },
  {
    title: "维修结束&满意度评价",
    status: "finish",
    icon: h(SmileOutlined),
  },
];
const listData1 = [
  {
    title: "维修费用",
    content:
      "具体维修费用将以您的产品检修结果为准，如属保修期内非人为的性能故障，将视情况免费为您维修或置换，同时免费为您提供备机以保证您的正常生产。对于保外维修，将依据检修结果产生一定费用，我们将在检测后向您发送报价单。",
  },
  {
    title: "物流费用",
    content:
      "保修期内产品维修政策，请点击此处查看。对于保外维修，所产生的费用由发运方承担。",
  },
  {
    title: "配件购买",
    content:
      "您可通过官方微信服务号“邦德激光Bodor”进入配件商城，或拨打客服热线400-166-1119查询价格及购买。受采购批次、时间及供应商因素影响，维修配件价格可能有所调整，请以购买时的官方价格为准。",
  },
  {
    title: "服务方式",
    content:
      "分为线上、线下两种服务方式。在不涉及安装、移机、部件更换等情况，为保障客户生产时效，优先以线上形式进行指导。",
  },
  {
    title: "响应时间",
    content: "线上申请保修后，我们将在30分钟内给予回复。期间请保持您的通讯设备运行畅通。",
  },
  {
    title: "其他维修方式",
    content: `除官网外，您还可以通过以下方式进行报修：
1、拨打客服热线400-166-1119，我们将安排售后工程师与您沟通。
2、登录官方微信服务号“邦德激光Bodor”菜单栏-服务支持-售后服务，进行相关操作。
3、发送您的维修需求至4001661119@bodor.cn，我们将在收到邮件的第一时间与您联系。
4、您可以通过扫描产品机身的超级二维码，进行报修申请。`,
  },
];
const assetsUrl = ref([
  require("@/assets/img/service/1.mp4"),
  require("@/assets/img/service/2.mp4"),
]);

/**
 * 主函数入口
 */
init();

function init() {}

/**点击上方导航卡片跳转 */
function jump(id) {
  const element = document.querySelector(`#${id}`);
  element && element.scrollIntoView({ block: "start", alignToTop: "false" });
}

/**左侧导航点击回调函数 */
function handleClick(e, link) {
  e.preventDefault();
}

/**返回上一页 */
function back() {
  history.back();
}
</script>

<style scoped>
.inner {
  width: 60%;
  min-width: 1100px;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
}
.anchor {
  position: absolute;
  left: 50px;
  top: 120px;
}
.navi {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.naviCard {
  box-shadow: 0 3px 14px 2px #0000000d, 0 8px 10px 1px #0000000f, 0 5px 5px -3px #0000001a;
  transition: 0.3s all ease-in-out;
  border-radius: 8px;
  width: 260px;
  height: 160px;
  position: relative;
  background-color: white;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  text-align: center;
  white-space: pre-wrap;
}
.hoverImg {
  width: 100%;
  height: 100%;
  position: absolute;
  background-image: url(@/assets/img/hover.png);
  opacity: 0;
  z-index: 1;
  transition: 0.3s all ease-in-out;
  border-radius: 8px;
}
.naviCard:hover {
  transform: translateY(-10px);
}
.naviCard:hover .hoverImg {
  opacity: 1;
}
.title {
  position: relative;
  z-index: 2;
  font-size: 24px;
  font-family: PingFangSC-Medium, sf-pro-text_medium, PingFang SC, "Microsoft YaHei";
  font-weight: 500;
  color: black;
  margin-bottom: 10px;
}
.describe {
  font-family: PingFangSC-Regular, sf-pro-text_regular, sf-pro-display_regular,
    PingFang SC, "Microsoft YaHei";
  font-weight: 400;
  font-size: 12px;
  color: black;
  z-index: 2;
}
.contentCard {
  width: 100%;
  margin-top: 40px;
  box-shadow: 0 3px 14px 2px #0000000d, 0 8px 10px 1px #0000000f, 0 5px 5px -3px #0000001a;
}
.artticle {
  width: 100%;
  border: none;
  padding: 0px;
  background-color: white;
  font-family: Menlo, Monaco, Consolas, -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  white-space: pre-wrap;
}
a {
  line-height: 32px;
}
.itemCard {
  border-radius: 8px;
  transition: 0.3s all;
  height: 200px;
  width: 95%;
  box-shadow: 0 3px 14px 2px #0000000d, 0 8px 10px 1px #0000000f, 0 5px 5px -3px #0000001a;
  cursor: pointer;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0px auto;
}
.itemCard:hover {
  transform: translateY(-10px);
  box-shadow: 0 3px 14px 2px #0000000d, 0 8px 10px 1px #0000000f, 0 5px 5px -3px #0000001a;
}
.itemtitle {
  text-align: center;
  font-family: PingFangSC-Semibold, sf-pro-display_semibold, sf-pro-text_semibold,
    PingFang SC, "Microsoft YaHei";
  font-weight: 600;
  color: black;
  font-size: 18px;
  margin: 15px 0px;
}
.itemdescribe {
  font-family: PingFangSC-Regular, sf-pro-text_regular, sf-pro-display_regular,
    PingFang SC, "Microsoft YaHei";
  font-weight: 400;
  color: black;
  font-size: 12px;
  text-align: center;
  white-space: pre-wrap;
}
.itemImg {
  width: 60px;
  height: 60px;
}
.column {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.fourthly-media {
  width: 1063px;
  height: 600px;
  border-radius: 8px;
  object-fit: cover;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  margin: 20px 0px 40px;
}
.three {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0px 14px;
  margin: 30px 0px 40px;
}
.three-item {
  border-radius: 8px;
  width: 256px;
  height: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  cursor: pointer;
  overflow: hidden;
}
.three-title {
  z-index: 2;
  position: absolute;
  top: 42px;
  font-family: PingFangSC-Medium, sf-pro-text_medium, PingFang SC, "Microsoft YaHei";
  font-weight: 500;
  font-size: 24px;
  color: white;
}
.three-img {
  transition: 0.3s all;
  object-fit: cover;
  width: 100%;
  height: 100%;
  border: none;
}
.three-item:hover img {
  transform: scale(1.2);
}
.three-info {
  transition: 0.3s all;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0;
  border-radius: 8px;
  padding-top: 100px;
  position: absolute;
  background: rgba(0, 0, 0, 0.8);
  line-height: 24px;
  text-align: center;
  font-family: PingFangSC-Medium, sf-pro-text_medium, PingFang SC, "Microsoft YaHei";
  font-weight: 500;
  font-size: 12px;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.three-item:hover .three-info {
  opacity: 1;
}
.three-explain {
  line-height: 12px;
  margin: auto;
  font-family: PingFangSC-Regular, sf-pro-text_regular, sf-pro-display_regular,
    PingFang SC, "Microsoft YaHei";
  font-weight: 400;
  font-size: 12px;
  color: #828898;
  width: 192px;
}
.orangeCard {
  border-radius: 8px;
  height: 330px;
  width: 330px;
  background-color: #fff8ee;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.flex-bet {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0px 14px;
}
.orangeCard > img {
  width: 64px;
  height: 64px;
  margin-bottom: 24px;
}
.orange-title {
  font-family: PingFangSC-Regular, sf-pro-text_regular, sf-pro-display_regular,
    PingFang SC, "Microsoft YaHei";
  font-weight: 400;
  font-size: 24px;
  color: black;
  text-align: center;
}
.teamCard {
  border-radius: 8px;
  width: 514px;
  height: 350px;
  cursor: pointer;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.team-front {
  align-items: center;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: 0.3s all;
  opacity: 1;
}
.team-title {
  line-height: normal;
  margin-top: 24px;
  font-family: PingFangSC-Regular, sf-pro-text_regular, sf-pro-display_regular,
    PingFang SC, "Microsoft YaHei";
  font-weight: 400;
  font-size: 48px;
  color: black;
}
.team-back {
  z-index: 2;
  opacity: 0;
  position: absolute;
  transition: 0.3s all;
  line-height: normal;
  margin-top: 24px;
  font-family: PingFangSC-Regular, sf-pro-text_regular, sf-pro-display_regular,
    PingFang SC, "Microsoft YaHei";
  font-weight: 400;
  font-size: 24px;
  color: black;
  text-align: center;
}
.teamCard:hover .team-front {
  opacity: 0;
}
.teamCard:hover .team-back {
  opacity: 1;
}
</style>
